import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

/** À compléter avec les informations définitives de votre juriste / expert-comptable */
const LEGAL = {
    raisonSociale: "EVENTS GROUP",
    formeJuridique: "SARL", // ou SA, EURL, etc.
    nomcommercial: "Events Billetterie",
    capitalSocial: "1 000 000",
    rccm: "CI-ABJ-03-2025-B12-06856",
    siege: "Angré 8ième Tranche, Cocody, Abidjan, Côte d'Ivoire",
};

export default function LegalMentions() {
    return (
        <div className="nc-PageSingle pt-8 lg:pt-16 mb-5">
            <Helmet>
                <title>Mentions légales - Events Billetterie</title>

                <meta
                    name="description"
                    content="Mentions légales du site Events Billetterie : éditeur, hébergement, propriété intellectuelle et données personnelles."
                />

                <meta
                    name="keywords"
                    content="mentions légales Events Billetterie, éditeur site, billetterie Côte d'Ivoire, eventsbilletterie"
                />

                <meta name="author" content="Events Billetterie" />

                <meta property="og:title" content="Mentions légales - Events Billetterie" />
                <meta
                    property="og:description"
                    content="Informations relatives à l'éditeur du site Events Billetterie et au cadre juridique."
                />
                <meta property="og:image" content="https://eventsbilletterie.com/assets/images/logo.png" />
                <meta property="og:url" content="https://eventsbilletterie.com/mentions-legales" />
                <meta property="og:type" content="website" />

                <link rel="canonical" href="https://eventsbilletterie.com/mentions-legales" />
            </Helmet>

            <header className="container rounded-xl">
                <div className="max-w-screen-md mx-auto space-y-5">
                    <h1
                        className="text-neutral-900 font-semibold text-3xl md:text-4xl md:!leading-[120%] lg:text-4xl dark:text-neutral-100 max-w-4xl"
                        title="Mentions légales"
                    >
                        Mentions légales
                    </h1>
                    <div className="w-full border-b border-neutral-200 dark:border-neutral-800 mb-5" />
                </div>
            </header>

            <div className="nc-SingleContent container space-y-10 mt-5">
                <div className="prose dark:prose-invert prose-sm !max-w-screen-md sm:prose lg:prose-lg mx-auto dark:prose-dark">
                    <h2>1. Éditeur du site</h2>
                    <p>
                        Le site internet accessible à l&apos;adresse{" "}
                        <a href="https://eventsbilletterie.com" className="text-primary-6000 hover:underline">
                            https://eventsbilletterie.com
                        </a>{" "}
                        (ci-après le « <strong>Site</strong> »), ainsi que l&apos;application mobile « <Link to="/go">Events Billetterie</Link>
                        » associée, sont édités par :
                    </p>
                    <ul>
                        <li>
                            <strong>Raison sociale :</strong> {LEGAL.raisonSociale}
                        </li>
                        <li>
                            <strong>Forme juridique :</strong> {LEGAL.formeJuridique}
                        </li>
                        <li>
                            <strong>Nom commercial :</strong> {LEGAL.nomcommercial}
                        </li>
                        <li>
                            <strong>Capital social :</strong> {LEGAL.capitalSocial} FCFA
                        </li>
                        <li>
                            <strong>Siège social :</strong> {LEGAL.siege}
                        </li>
                        <li>
                            <strong>Immatriculation :</strong> {LEGAL.rccm}
                        </li>
                        <li>
                            <strong>Numéro de téléphone :</strong>{" "}
                            
                            <a href="tel:+2250717519518" className="text-primary-6000 hover:underline">
                                +225 07 79 98 9265 
                            </a>
                            &nbsp;/&nbsp;
                            <a href="tel:+2250717519518" className="text-primary-6000 hover:underline">
                             07 17 51 9518
                            </a>
                        </li>
                        <li>
                            <strong>Courriel :</strong>{" "}
                            <a href="mailto:contact@eventsbilletterie.com" className="text-primary-6000 hover:underline">
                                contact@eventsbilletterie.com
                            </a>
                        </li>
                    </ul>

                    <h2>2. Propriété intellectuelle</h2>
                    <p>
                        L&apos;ensemble des éléments composant le Site (textes, graphismes, logo, icônes, structure,
                        bases de données, logiciels, vidéos, photographies, etc.) sont la propriété exclusive de
                        l&apos;éditeur ou de ses partenaires, sauf mention contraire. Toute reproduction, représentation,
                        modification, publication ou adaptation, totale ou partielle, est interdite sans autorisation
                        écrite préalable, sous peine de poursuites conformément au droit ivoirien et aux conventions
                        applicables en matière de propriété intellectuelle.
                    </p>
                    <p>
                        La marque « Events » / « Events Billetterie » et les signes distinctifs associés sont des marques
                        exploitées dans le cadre de l&apos;activité de billetterie événementielle. Toute utilisation non
                        autorisée est interdite.
                    </p>

                    <h2>3. Données personnelles</h2>
                    <p>
                        Les traitements de données personnelles mis en œuvre via le Site et l&apos;application sont
                        décrits dans notre{" "}
                        <Link to="/Events-usedFolder/politique-confidentielle" className="text-primary-6000 hover:underline">
                            Politique de confidentialité
                        </Link>
                        . Vous disposez de droits d&apos;accès, de rectification et de suppression dans les conditions
                        prévues par la réglementation applicable ; pour exercer ces droits, vous pouvez nous écrire à{" "}
                        <a href="mailto:contact@eventsbilletterie.com" className="text-primary-6000 hover:underline">
                            contact@eventsbilletterie.com
                        </a>
                        .
                    </p>

                    <h2>4. Conditions d&apos;utilisation</h2>
                    <p>
                        L&apos;utilisation du Site implique l&apos;acceptation des{" "}
                        <Link to="/Events-usedFolder/conditions-generales-utilisations" className="text-primary-6000 hover:underline">
                            Conditions générales d&apos;utilisation (CGU)
                        </Link>
                        .
                    </p>

                    <h2>5. Limitation de responsabilité</h2>
                    <p>
                        L&apos;éditeur s&apos;efforce d&apos;assurer l&apos;exactitude et la mise à jour des informations
                        diffusées sur le Site. Toutefois, aucune garantie n&apos;est apportée quant à
                        l&apos;exhaustivité, l&apos;exactitude ou la disponibilité continue du Site. L&apos;éditeur ne
                        saurait être tenu responsable des dommages directs ou indirects résultant de l&apos;accès ou de
                        l&apos;utilisation du Site.
                    </p>
                </div>
            </div>
        </div>
    );
}
